import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import classnames from 'classnames';

import style from './Tooltip.module.scss';

export const Tooltip = ({ placement = 'bottomRight', title, vendorClass, children }) => (
  <AntTooltip placement={ placement } title={ title } overlayClassName={ classnames(style.tooltip, vendorClass) }>
    {children}
  </AntTooltip>
);
